import { CheckCircleIcon, PlusIcon } from '@heroicons/react/24/solid'
import { IntegrationsRow } from 'app/types/integrations'

export function IntegrationCard({
  name,
  id,
  icon,
  onClick,
  currentSelection,
  workspaceBadge,
  matIcon,
}: {
  name: string
  id: IntegrationsRow[`integration`]
  icon: string
  onClick: () => void
  currentSelection?: string
  workspaceBadge?: `required` | `connected`
  // The vendor PNG bakes in an opaque white background (Jotform, Sikka,
  // Kolla, Gravity Forms, Webflow Forms); mat it so it does not render as a
  // stray white box on this card's dark-mode `bg-surface`.
  matIcon?: boolean
}) {
  return (
    <button
      className="flex h-[160px] w-[268px] flex-col rounded-lg border border-default bg-surface p-4 shadow-elevation-1"
      data-testid={`integration-card-${id}`}
      onClick={onClick}
    >
      <div className="flex w-full items-center justify-between">
        <p className="text-ui-xs text-subtle">{name}</p>
        {currentSelection !== id ? (
          <PlusIcon className="h-8 w-8 text-default" />
        ) : (
          <CheckCircleIcon className="h-8 w-8 text-blue-500" />
        )}
      </div>
      <div className="flex w-full grow items-center justify-center">
        {matIcon ? (
          // ast-grep-ignore: no-raw-neutral-color
          <span className="inline-flex rounded bg-white p-1">
            <img className="h-10 w-auto" src={icon} alt={name} />
          </span>
        ) : (
          <img className="h-12 w-auto" src={icon} alt={name} />
        )}
      </div>
      {workspaceBadge === `required` && (
        <span className="rounded-full bg-amber-100 px-2 py-0.5 text-ui-xs text-amber-800">Needs workspace setup</span>
      )}
      {workspaceBadge === `connected` && (
        <span className="flex items-center gap-1 rounded-full bg-surface-muted px-2 py-0.5 text-ui-xs text-subtle">
          <CheckCircleIcon className="h-3.5 w-3.5 text-green-600" />
          Workspace connected
        </span>
      )}
    </button>
  )
}
